import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Typography, Breadcrumb, Space, Grid } from 'antd';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Publications({ content }) {
  const { xs } = useBreakpoint()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const pageContent = content || {};
  const introParagraphs = Array.isArray(pageContent.introParagraphs)
    ? pageContent.introParagraphs
    : [];
  const opportunitiesTitle = pageContent.opportunitiesTitle || 'List of Journal';
  const opportunities = Array.isArray(pageContent.opportunities)
    ? pageContent.opportunities
    : [];
  const proceedingsTitle = pageContent.proceedingsTitle || 'Proceedings';
  const proceedingsItems = Array.isArray(pageContent.proceedingsItems)
    ? pageContent.proceedingsItems
    : [];
  const additionalNotesTitle = pageContent.additionalNotesTitle || 'Additional Notes';
  const additionalNotes = Array.isArray(pageContent.additionalNotes)
    ? pageContent.additionalNotes
    : [];

  if (content?.comingSoon) {
    const message = String(content?.comingSoonMessage || 'Content for WCHSS 2026 is coming soon');

    return (
      <React.Fragment>
        <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
          <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
            <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
              <Breadcrumb.Item>
                <Link to="/">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Publications</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={24}>
            <Text style={{ fontSize: 16 }}>{message}</Text>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Publications</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 16 : 32}>
            <Space direction="vertical" size={16}>
              <Text style={{ fontSize: xs ? 21 : 28, fontWeight: 'bold', lineHeight: 'normal' }}>Publications</Text>
              <Space direction="vertical" size={8}>
                {introParagraphs.map((text, index) => (
                  <Text key={index} style={{ fontSize: 16 }}>{text}</Text>
                ))}
              </Space>
            </Space>
            <Space direction="vertical" size={16}>
              <Text style={{ fontSize: xs ? 21 : 28, fontWeight: 'bold', lineHeight: 'normal' }}>{opportunitiesTitle}</Text>
              <ul style={{ marginLeft: -24 }}>
                {opportunities.map((text, index) => (
                  <li key={index}><Text style={{ fontSize: 16 }}>{text}</Text></li>
                ))}
              </ul>
            </Space>
            <Space direction="vertical" size={16}>
              <Text style={{ fontSize: xs ? 21 : 28, fontWeight: 'bold', lineHeight: 'normal' }}>{proceedingsTitle}</Text>
              <ul style={{ marginLeft: -24 }}>
                {proceedingsItems.map((text, index) => (
                  <li key={index}><Text style={{ fontSize: 16 }}>{text}</Text></li>
                ))}
              </ul>
              <Text style={{ fontSize: xs ? 21 : 28, fontWeight: 'bold', lineHeight: 'normal' }}>{additionalNotesTitle}</Text>
              <ul style={{ marginLeft: -24 }}>
                {additionalNotes.map((text, index) => (
                  <li key={index}><Text style={{ fontSize: 16 }}>{text}</Text></li>
                ))}
              </ul>
            </Space>
            <Space direction="vertical" size={16}>
              <Text style={{ fontSize: xs ? 21 : 28, fontWeight: 'bold', lineHeight: 'normal' }}>Review Procedure</Text>
              <Space direction='vertical' size={24}>
                <Space direction='vertical'>
                  <Text style={{ fontSize: 16 }}>All articles would have been peer reviewed by the members of the <Text italic style={{ color: '#0D6E49' }}>The 2nd World Conference on Health and Social Sciences 2024 Scientific Committee</Text> and approved by the Editor-in-Chief, who has affirmed that this document was a truthful description of the conference’s review process.</Text>
                  <Text style={{ fontSize: 16 }}>The reviews have been done in <Text italic style={{ color: '#0D6E49' }}>single-blind method</Text>. Each submission was examined by <Text italic style={{ color: '#0D6E49' }}>at least two</Text> reviewer(s) independently.</Text>
                  <Text style={{ fontSize: 16 }}>The submissions shall first be screened for generic quality and suitableness. After the initial screening, they were sent for peer review by matching each paper’s topic with the reviewers’ expertise, taking into account any competing interests. A paper could only be considered for acceptance if it had received favourable recommendations from the two reviewers.</Text>
                  <Text style={{ fontSize: 16 }}>The authors requires to comply with the standards and requirements mentioned in Springer Nature’s policies and guidelines for books and chapters and Springer Nature’s Ethical Approval and Informed Consent for Studies Involving Animals and/or Humans Policy (<a href='https://www.springernature.com/gp/policies/book-publishing-policies' target="_blank" rel="noreferrer">https://www.springernature.com/gp/policies/book-publishing-policies</a>).</Text>
                  <Text style={{ fontSize: 16 }}>Springer Nature requires authors to be transparent throughout the ethical approval process and research process. When including primary studies in a book/ chapter manuscript with human participants, authors must adhere to the ethical standards as laid down in the 1964 Declaration of Helsinki and its later amendments or comparable ethical standards. Authors should report that the study was reviewed and approved by an appropriate ethics review committee and must include the name of the ethics committee and the reference number where appropriate. This information is also a requirement for Abstracting and Indexing Services in certain disciplines.</Text>
                  <Text style={{ fontSize: 16 }}>In addition, for human participants, authors are required to include a statement that informed consent (to participate and / or to publish) was obtained from individual participants or parents/ guardians if the participant is minor or incapable.</Text>
                </Space>
                <Space direction='vertical'>
                  <Text style={{ fontSize: 16 }}>If animals are studied, authors should make sure that the legal requirements or guidelines in the country and/or state or province for the care and use of animals have been followed or specify that no ethics approval was required.</Text>
                  <Text style={{ fontSize: 16 }}>Authors of a rejected submission were given the opportunity to revise and resubmit after addressing the reviewers’ comments. The acceptance or rejection of a revised manuscript was final.</Text>
                  <Text style={{ fontSize: 16 }}>Furthermore, Springer Nature reserves the right to reject manuscripts that do not comply with these requirements. Authors will be held responsible for false statements or failure to fulfil these requirements.</Text>
                  <Text style={{ fontSize: 16 }}>Reviewers were instructed to assess the quality of submissions solely based on the academic merit of their content along the following dimensions</Text>
                  <ol style={{ marginLeft: -24, marginTop: 0, marginBottom: 0 }}>
                    <li><Text style={{ fontSize: 16 }}>Pertinence of the article’s content to the scope and themes of the conference;</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Clear demonstration of originality, novelty, and timeliness of the research;</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Soundness of the methods, analyses, and results;</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Adherence to the ethical standards and codes of conduct relevant to the research field;</Text></li>
                    <li><Text style={{ fontSize: 16 }}>Clarity, cohesion, and accuracy in language and other modes of expression, including figures and tables.</Text></li>
                  </ol>
                  <Text style={{ fontSize: 16 }}>In addition, all of the articles would have been checked for textual overlap in an effort to detect possible signs of plagiarism by the publisher.</Text>
                </Space>
              </Space>
            </Space>
            <Space direction="vertical" size={16}>
              <Text style={{ fontSize: xs ? 21 : 28, fontWeight: 'bold', lineHeight: 'normal' }}>Academic Journal (National Research Journal by Binawan University, accredited SINTA 5)</Text>
              <Text style={{ fontSize: 16 }}>Selected papers from WCHSS may be invited for publication in special issues of academic journal. These special issues provide authors with the opportunity for further peer review and publication in high-impact outlets, enhancing the visibility and reach of their research within the academic community.</Text>
            </Space>
            <Text italic style={{ fontSize: 16 }}>Join us at WCHSS and take advantage of the publication opportunities available to showcase your research and contribute to the advancement of health and social sciences worldwide. We look forward to receiving your submissions and sharing your insights with the global academic community.</Text>
          </Space>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Publications